module.exports = __webpack_public_path__ + "img/bg-program-consultation-mobile.7c304dc5.png";